pcstyle();
//监听屏幕改变resize事件 触发remChange方法
window.addEventListener("resize", pcstyle);
var scale = 1;
export function pcstyle() {
  var doc = window.document;
    var docEl = doc.documentElement;
    document.body.id = "appmain";
  var div = window.document.getElementsByClassName("app");
  var div2 = window.document.getElementById("appmain");

  var width = docEl.getBoundingClientRect().width;
  scale = width / 1920;
  div2.setAttribute("style", "zoom: " + scale);
}
// 公共的js
//日期格式转换
export function FromDates(StringDate) {
  let T = "",
    N = "",
    Y = "",
    R = "";
  for (let i = 0; i < StringDate.length; i++) {
    N = StringDate.substring(0, 4) + "-";
    Y = StringDate.substring(4, 6) + "-";
    R = StringDate.substring(6, 8);
    T = N + Y + R;
    return T;
  }
}
//日期时间去横杠
export function FromDatesCancle(StringDate) {
  let CanTime = [];
  for (let i = 0; i < StringDate.length; i++) {
    if (StringDate[i] !== "-") {
      CanTime.push(StringDate[i]);
    }
  }
  return CanTime.join("");
}

export function toshowis() {
  console.log("is");
}

//排序
export function objKeySort(obj) {
  var newkey = Object.keys(obj).sort();
  var newObj = {};
  for (var i = 0; i < newkey.length; i++) {
    newObj[newkey[i]] = obj[newkey[i]];
  }
  return newObj;
}

//拼接
export function genSign(obj, apikey) {
  //	console.log(obj);
  if (obj.sign) {
    delete obj.sign;
  }
  var str = "";
  var newkey = Object.keys(obj);
  for (var i = 0; i < newkey.length; i++) {
    str += newkey[i] + "=" + obj[newkey[i]];
  }
  str += apikey;
  console.log(str);
  return str;
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js